import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthService } from "../auth/auth.service";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable({
  providedIn: "root",
})
export class UserService {
  entity: string = "/users";

  constructor(private http: HttpClient, private authService: AuthService) {}

  get(token: string): Observable<any> {
    return this.http.get(
      environment.api + "/users/me?populate=profile.avatar,stripe,role",
      {
        headers: {
          Authorization: "Bearer " + token,
          "content-type": "application/json",
        },
      }
    );
  }

  getById(id: any,jwt: string): Observable<any> {
    return this.http.get(
      environment.api + "/users/"+id,
      {
        headers: {
          Authorization: "Bearer " + jwt,
          "content-type": "application/json",
        },
      }
    );
  }

  change_password(values: any) {
    return this.http.post(environment.api + "/custom/change-password", values, {
      headers: {
        Authorization: "Bearer " + this.authService.currentUserValue.token,
      },
    });
  }

  update(id: string, data: any): Observable<any> {
    return this.http.put(environment.api + "/users/" + id, data, {
      headers: {
        Authorization: "Bearer " + this.authService.currentUserValue.token,
      },
    });
  }

  delete(data: any) {
    return this.http.post(
      environment.api + "/profiles/delete-my-account",
      data,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
        },
      }
    );
  }
}
